import React, { ReactNode } from 'react';

interface GentuxEmProps {
  children?: ReactNode;
}

const GentuxEm = ({ children }: GentuxEmProps): JSX.Element => <strong className="GentuxEm font-bold text-gold-darker">{children}</strong>;

export default GentuxEm;
